import { ImgHTMLAttributes, useState, useEffect } from 'react';

type ImageProps = ImgHTMLAttributes<HTMLImageElement> & {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  priority?: boolean;
  quality?: number;
};

export const Image = ({ 
  src, 
  alt, 
  width, 
  height, 
  priority = false, 
  className = '',
  ...props 
}: ImageProps) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  
  useEffect(() => {
    setIsMounted(true);
  }, []);
  
  const isSvg = typeof src === 'string' && src.endsWith('.svg');
  
  // For SSR: always start with opacity-100 to avoid hydration mismatch
  // Only apply fade-in effect on client after mount
  const opacityClass = isSvg || !isMounted ? 'opacity-100' : (isLoaded ? 'opacity-100' : 'opacity-0');
  
  const imgProps: ImgHTMLAttributes<HTMLImageElement> = {
    src,
    alt,
    loading: priority ? 'eager' : 'lazy',
    decoding: priority ? 'sync' : 'async',
    onLoad: () => setIsLoaded(true),
    className: `${className} ${opacityClass} transition-opacity duration-300`,
    ...props
  };

  if (width) imgProps.width = width;
  if (height) imgProps.height = height;

  // Simplified: always render plain img tag to avoid hydration mismatch
  // The aspect ratio wrapper was causing SSR/client differences
  return <img {...imgProps} />;
};
